import { useRef, type ReactElement } from 'react'

import { type PageComponentProps } from '@typings/components/page'

import { Column } from '@components/ui-core/column/column'
import { HeaderType } from '@components/ui-core/header/header'

import { PageLayout } from '@custom/components/page-layout/page-layout'
import { TrustedBy } from '@custom/components/trusted-by/trusted-by'

import { plansPageData } from './content'
import { FeaturesComparison } from './features-comparison/features-comparison'
import { PlansComparisonFloatingHeader } from './features-comparison/plans-comparison-floating-header'
import { Intro } from './intro/intro'
import { PlansComparison } from './plans-comparison/plans-comparison'
import { Testimonials } from './testimonials/testimonials'
import { type PlanKind } from './types'
import { parseFlags } from './utils'

import styles from './page.module.scss'

const {
  introSection,
  plansComparisonSection,
  trustedBySection,
  testimonialsSection,
  featuresComparisonSection,
} = plansPageData

function PlansPage({ data, enabledFlags }: PageComponentProps): ReactElement {
  const highlighted: PlanKind = 'business'
  const featuresRef = useRef<HTMLDivElement | null>(null)
  const plansPageFlags = parseFlags(enabledFlags)
  return (
    <PageLayout data={data} headerType={HeaderType.Global} withFooter className={styles.plansPage}>
      <Column as="section" className={styles.background}>
        <Intro data={introSection} />
        <PlansComparison
          data={plansComparisonSection}
          highlighted={highlighted}
          featuresRef={featuresRef}
          plansPageFlags={plansPageFlags}
        />
        <TrustedBy data={trustedBySection} className={styles.trustedBy} />
      </Column>
      <Testimonials data={testimonialsSection} />
      <PlansComparisonFloatingHeader
        data={plansComparisonSection}
        highlighted={highlighted}
        featuresRef={featuresRef}
        plansPageFlags={plansPageFlags}
      />
      <FeaturesComparison
        data={featuresComparisonSection}
        highlighted={highlighted}
        featuresRef={featuresRef}
      />
    </PageLayout>
  )
}

export default PlansPage
